import type { Store } from '../../../store/player/types';

export const isDebugActive = (store: Store, eventType: string): boolean => {
  const { debugAllEvents, debugSpecificEvents } = store.getState();

  return debugAllEvents || debugSpecificEvents.indexOf(eventType) > -1;
};
